// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class AlertMessage extends PFixMessage {
    get isAllowOTHTrading() {
        return this.getFieldValue(FieldsFactory.FIELD_ALLOW_OTH_TRADING);
    }
    set isAllowOTHTrading(value) {
        if (!isNullOrUndefined(value)) {
            this.setFieldValue(FieldsFactory.FIELD_ALLOW_OTH_TRADING, value);
        }
    }
    constructor(fieldSet) {
        super(Message.CODE_ALERT_MESSAGE, fieldSet);
    }
    getAccountId() {
        return this.getFieldValue(FieldsFactory.FIELD_ACCOUNT_ID);
    }
    getUserId() {
        return this.getFieldValue(FieldsFactory.FIELD_USER_ID);
    }
    getTradableInstrumentId() {
        return this.getFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    getRouteId() {
        return this.getFieldValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    getAlertId() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_ID);
    }
    getAlertType() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_TYPE);
    }
    getAlertCondition() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_CONDITION);
    }
    getAlertValue() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_VALUE);
    }
    getAlertImportance() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_IMPORTANCE);
    }
    getAlertDate() {
        return this.getFieldValue(FieldsFactory.FIELD_DATE);
    }
    getAlertAfterExecute() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_AFTER_EXECUTE);
    }
    getAlertAction() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_ACTION);
    }
    getAlertNotification() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_NOTIFICATION);
    }
    getAlertText() {
        return this.getFieldValue(FieldsFactory.FIELD_TEXT);
    }
    getAlertEvent() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_EVENT);
    }
    getAlertStatus() {
        return this.getFieldValue(FieldsFactory.FIELD_ALERT_STATUS);
    }
}
